import store from "../store";
import connect_api from "../connect/connect_api";
import socket_connect from "../connect/socket_connect";
import config from "../config";

let token_timer;
function start_token_refresh() {
  let time_to_start = token_timeout();
  if (time_to_start && time_to_start > 100) {
    console.log("start timer for token refresh " + time_to_start);
    clearTimeout(token_timer);
    token_timer = setTimeout(function () {
      refreshToken();
    }, time_to_start);
    return true;
  } else {
    console.log("too late for refresh " + time_to_start);
  }
  return false;
}

function token_timeout() {
  const state = store.getState();
  if (state.authR.token.token_expires) {
    let new_timeout = state.authR.token.token_expires - Date.now() - 10000;
    if (new_timeout < 0) {
      return false;
    } else {
      return new_timeout;
    }
  } else {
    return false;
  }
}

function check_token_timeout() {
  const state = store.getState();
  if (state.authR.token.token_expires) {
    let new_timeout = state.authR.token.token_expires - Date.now() - 3000;
    if (new_timeout < 0) {
      return false;
    } else {
      return new_timeout;
    }
  } else {
    return false;
  }
}

function refreshToken() {
  console.log("SESSION REFRESH started");
  connect_api.sPOST("/auth/refresh", {}, function (error, response) {
    if (!error) {
      store.dispatch({
        type: "TOKEN_REFRESHED",
        data: response.api_data,
      });
      start_token_refresh();
    } else {
      if (error.message !== "Server connection error") {
        store.dispatch({
          type: "TOKEN_REFRESH_FAILED",
        });
      }
      start_token_refresh();
    }
  });
}

function resume() {
  return start_token_refresh();
}

function login(callback) {
  const state = store.getState();
  let login = {
    username: state.authR.login.username,
    password: state.authR.login.password,
    relogin: false,
  };
  connect_api.POST("/login", login, function (error, response) {
    if (!error) {
      store.dispatch({
        type: "LOGGED_IN",
        data: response.api_data,
      });
      socket_connect.disconnect();
      socket_connect.startSocket();
      if (config.auto_refresh) {
        start_token_refresh();
      }
      callback(false, response.api_data);
    } else {
      store.dispatch({
        type: "ERROR_LOGIN",
      });

      callback(error, false);
    }
  });
}

function login_silent(callback) {
  const state = store.getState();
  let login = {
    username: state.authR.login.username,
    password: state.authR.login.password,
    relogin: true,
  };
  connect_api.POST("/login", login, function (error, response) {
    if (!error) {
      store.dispatch({
        type: "LOGGED_IN",
        data: response.api_data,
      });
      socket_connect.disconnect();
      socket_connect.startSocket();
      callback(false, response.api_data);
    } else {
      store.dispatch({
        type: "ERROR_LOGIN",
      });
      callback(error, false);
    }
  });
}

function logout(type = "SESSION_TIMEOUT") {
  clearTimeout(token_timer);
  store.dispatch({
    type: type,
  });
}

function isAuth() {
  const state = store.getState();
  if (state && config.auto_relogin && state.authR.isAuth) {
    return true;
  }
  if (state && token_timeout() && state.authR.isAuth) {
    return true;
  }
  return false;
}

export default {
  login: login,
  login_silent: login_silent,
  isAuth: isAuth,
  logout: logout,
  resume: resume,
  token_timeout: token_timeout,
  check_token_timeout: check_token_timeout,
};
